import { ReactComponent as FaceBookIcon } from '../../assets/facebook.svg';
import { ReactComponent as InstagramIcon } from '../../assets/instagram.svg';
import { ReactComponent as YouTubeIcon } from '../../assets/youtube.svg';
import style from './style.module.scss';
import clsx from 'clsx';

function SocialButton({ socialNetwork, url, backgroundColor }) {
    const socialIcon = {
        facebook: <FaceBookIcon />,
        instagram: <InstagramIcon />,
        youtube: <YouTubeIcon />,
    }[socialNetwork];

    return (
        <a
            className={clsx(style.socialButton, style[backgroundColor])}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {socialIcon}
        </a>
    );
}

export default SocialButton;
